import { Injectable } from '@angular/core';
import { HelpText } from './../../model/help-text';

@Injectable()
export class HelpTextFactory {
  constructor() {}

  create(text: string): HelpText {
    return new HelpText(text);
  }

  createLink(caption: string, href: string, text: string): HelpText {
    return new HelpText(text, { caption: caption, href: href });
  }
}
